import { render, staticRenderFns } from "./allowance-bill.vue?vue&type=template&id=2b55b73e&scoped=true&"
import script from "./allowance-bill.vue?vue&type=script&lang=js&"
export * from "./allowance-bill.vue?vue&type=script&lang=js&"
import style0 from "./allowance-bill.vue?vue&type=style&index=0&id=2b55b73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b55b73e",
  null
  
)

export default component.exports